import * as React from 'react';
import { Checkbox } from '@verclam/ui-kit';

type Props = {
	readonly sectionKey: string;
	readonly checked: boolean;
	readonly disabled?: boolean;
	readonly onToggle: (sectionKey: string) => void;
};

/** One "Section de réévaluation" box, bound to the section it marks. */
const ReevaluationSectionCheckbox: React.FC<Props> = ({ sectionKey, checked, disabled, onToggle }) => {
	const handleChange = React.useCallback(() => {
		onToggle(sectionKey);
	}, [onToggle, sectionKey]);

	return (
		<Checkbox
			name={`reevaluation-${sectionKey}`}
			label="Section de réévaluation"
			checked={checked}
			disabled={disabled}
			onChange={handleChange}
		/>
	);
};

export default ReevaluationSectionCheckbox;
